import React, { PropsWithChildren, useRef, useState } from 'react'
import './index.scss'
import { v4 as uuidv4 } from 'uuid'
import clsx from 'clsx'
import MlcPopoverMenu from '@Components/Tooltips/MlcPopoverMenu'
import { PlacesType } from 'react-tooltip'

interface DotsPopoverProps {
    place?: PlacesType
    clickableComponentOverride?: React.ReactNode
}

const DotsPopover = ({ place, clickableComponentOverride, children }: PropsWithChildren<DotsPopoverProps>) => {
    const [popoverOpen, setPopoverOpen] = useState<boolean>(false)

    const handleClick = () => {
        setPopoverOpen(!popoverOpen)
    }
    const closePopover = () => {
        setPopoverOpen(false)
    }
    const toolTipId = useRef(uuidv4()).current

    const ClickableComponent = clickableComponentOverride ?? <div className="dots" />

    return (
        <>
            <MlcPopoverMenu
                clickableComponent={ClickableComponent}
                menuComponent={children}
                closeMenu={closePopover}
                classNames={clsx('popover-dots-wrapper', popoverOpen && 'hovered')}
                dataTooltipId={toolTipId}
                dataTestId="dots-popover"
                handleClick={handleClick}
                popoverOpen={popoverOpen}
                place={place}
            />
        </>
    )
}

export default DotsPopover
